export default {
  name: "GmRole"
};